function getFilesFromEvent(event) {
  const isDragEvent = "dataTransfer" in event;
  const filesFromEvent = (isDragEvent ? event.dataTransfer.files : event.target.files) ?? [];
  return Array.from(filesFromEvent);
}

export { getFilesFromEvent };
//# sourceMappingURL=getFilesFromEvent.mjs.map
